<template>
    <div class="summary">
        <div class="summary_bag">
            <!-- 搜索区域 -->
            <div class="summary_top_shop">
                <div class="role-Choice">
                    <span>选择站点：</span>
                    <el-select v-model="shopId" @change="shopChange" filterable placeholder="请选择站点">
                        <el-option v-for="item in dianpuList" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div class="summary_Date">
                <div class="block">
                    <span class="demonstration">选择开始日期：</span>
                    <el-date-picker v-model="startTime" align="right" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </div>
                <div class="block">
                    <span class="demonstration">选择结束日期：</span>
                    <el-date-picker v-model="endTime" align="right" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                </div>
                <div class="block">
                    <span class="demonstration">状态：</span>
                    <el-select v-model="status" placeholder="请选择状态" clearable>
                        <el-option label="在售" value="BUYABLE"></el-option>
                        <el-option label="停售" value="DISCOVERABLE"></el-option>
                    </el-select>
                </div>
                <div class="block">
                    <span class="demonstration">Listing匹配：</span>
                    <el-select v-model="pairStatus" placeholder="请选择状态" clearable>
                        <el-option label="未配对" :value="0"></el-option>
                        <el-option label="已配对" :value="1"></el-option>
                    </el-select>
                </div>
                <div class="block price">
                    <span class="demonstration">价格：</span>
                    <el-select v-model="currency" filterable style="width: 100px" clearable placeholder="币种">
                        <el-option :label="item.country" :value="item.currencyCode" v-for="item in bizhongOptions" :key="item.id"></el-option>
                    </el-select>
                    <span class="text">介于</span>
                    <el-input v-model="priceMin" style="width: 100px" clearable placeholder="最小值"></el-input>
                    <span class="text">和</span>
                    <el-input v-model="priceMax" style="width: 100px" clearable placeholder="最大值"></el-input>
                    <span class="text">之间</span>
                </div>
                <div class="block search-bar">
                    <el-input clearable placeholder="请输入查询内容" v-model="searchStr" 
                    @input="searchStr = searchStr.trim()">
                        <el-select v-model="searchType" slot="prepend" style="width: 100px" clearable>
                            <el-option label="SKU" value="sku"></el-option>
                            <el-option label="fnSku" value="fnSku"></el-option>
                            <el-option label="asin" value="asin"></el-option>
                            <el-option label="标题" value="itemName"></el-option>
                        </el-select>
                    </el-input>
                    <span class="demonstration search" @click="serach">搜索</span>
                    <span class="demonstration search" @click="searchReset">重置</span>
                </div>
            </div>
            <div class="summary_pagenum">
                <div class="summary_query">
                    符合查询条件的产品共
                    <span>{{ total }}</span>
                    件
                </div>
            </div>
            <div class="summary_content">
                <div class="summary_batch">
                    <div>
                        <span style="border-left:0">已选择产品{{ batch_select.length }}件</span>
                    </div>
                    <div>
                        <span @click="del">更新数据</span>
                    </div>
                    <div>
                        <span @click="updPrice">修改价格</span>
                    </div>
                </div>
                <!-- 表格区域 -->
                <div class="summary_list">
                    <el-table ref="multipleTable" :data="summarylist" style="width: 100%" v-loading="load_data"
                        element-loading-text="拼命加载中" border @selection-change="on_batch_select"
                        :header-cell-style="iscenter" stripe>
                        <el-table-column type="selection" width="50" align="center"></el-table-column>
                        <el-table-column label="主图" width="120" align="center">
                            <template slot-scope="scope">
                                <el-popover trigger="hover" placement="right">
                                    <img :src="scope.row.mainImage" class="prduct_img" alt />
                                    <div class="scope_img" slot="reference">
                                        <img :src="scope.row.mainImage" alt />
                                    </div>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column  label="SKU/FNSKU" align="left">
                            <template slot-scope="scope">
                                <div class="sku-cell">
                                    <div class="text">{{ scope.row.sku }}</div>
                                    <el-tooltip v-if="scope.row.sku" class="item" effect="dark" content="复制" placement="top">
                                        <el-button icon="el-icon-document-copy" @click="copyText1(scope.row.sku)"></el-button>
                                    </el-tooltip>
                                </div>
                                <div class="sku-cell">
                                    <div class="text">{{ scope.row.fnSku ? scope.row.fnSku : '-' }}</div>
                                    <el-tooltip v-if="scope.row.fnSku" class="item" effect="dark" content="复制" placement="top">
                                        <el-button icon="el-icon-document-copy" @click="copyText1(scope.row.fnSku)"></el-button>
                                    </el-tooltip>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="asin" label="ASIN" align="center" width="130"></el-table-column>
                        <el-table-column prop="checkStatus" label="状态" width="60" align="center">
                            <template slot-scope="scope">
                                <div :class="scope.row.status === '在售' ? 'green-box' : 'red-box'">
                                    <span>{{ scope.row.status }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="itemName" label="Listing配对">
                            <template slot-scope="scope">
                                <template v-if="scope.row.pairStatus === 1">
                                    <div class="sku-cell">
                                        <div class="text">{{ scope.row.productLibraryList[0].name }}</div>
                                        <el-tooltip v-if="scope.row.productLibraryList[0].name" class="item" effect="dark" content="复制" placement="top">
                                            <el-button icon="el-icon-document-copy" @click="copyText1(scope.row.productLibraryList[0].name)"></el-button>
                                        </el-tooltip>
                                    </div>
                                    <div class="sku-cell">
                                        <div class="text">{{ scope.row.productLibraryList[0].sku ? scope.row.productLibraryList[0].sku : '-' }}</div>
                                        <el-tooltip v-if="scope.row.productLibraryList[0].sku" class="item" effect="dark" content="复制" placement="top">
                                            <el-button icon="el-icon-document-copy" @click="copyText1(scope.row.productLibraryList[0].sku)"></el-button>
                                        </el-tooltip>
                                    </div>
                                </template>
                                
                            </template>
                        </el-table-column>
                        <el-table-column prop="deliveryMethod" label="配送方式" width="80"></el-table-column>
                        <el-table-column prop="priceB2c" label="售价" width="80"></el-table-column>
                        <el-table-column prop="priceB2b" label="B2B价格" width="80"></el-table-column>
                        <el-table-column prop="currencyCode" label="币种" width="60"></el-table-column>
                        <el-table-column prop="countryName" label="国家" width="80"></el-table-column>
                        <el-table-column prop="itemName" label="标题">
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" :content="scope.row.itemName"
                                    placement="top-start">
                                    <div class="title-cell">{{ scope.row.itemName }}</div>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="createdDate" label="创建时间" width="150" align="center"></el-table-column>
                        <el-table-column prop="lastUpdatedDate" label="更新时间" width="150" align="center"></el-table-column>
                        <el-table-column label="操作" fixed="right" width="80" align="center">
                            <template slot-scope="scope">
                                <!-- <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button> -->
                                <el-dropdown @command="(command) => handleCommand(command, scope.row)" trigger="click">
                                    <el-button type="text" size="small">
                                        操作<i class="el-icon-arrow-down el-icon--right"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                        <!-- pairStatus -->
                                        <el-dropdown-item command="pair" v-if="scope.row.pairStatus === 0">配对</el-dropdown-item>
                                        <el-dropdown-item command="unpair" v-if="scope.row.pairStatus === 1">取消配对</el-dropdown-item>
                                    </el-dropdown-menu>
                                </el-dropdown>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <!-- 分页 -->
            <div class="summary_pagenum_block">
                <div class="block">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="currentPage4" :page-sizes="[10, 20, 50, 100]"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
        <div style="height: 30px"></div>
        <!-- 产品配对 -->
        <el-dialog title="产品配对" :visible.sync="pairDialogVisible" width="80%" :close-on-click-modal="false"
            :append-to-body="true" top="60px">
            <ProductMatcher v-if="pairDialogVisible" @match="handleProductMatch" @close="pairDialogVisible = false" />
        </el-dialog>
        <!-- 修改价格 -->
        <el-dialog title="修改价格" :visible.sync="updPriceDialogVisible" @close="updPriceDialogVisible = false;visibleForPricePopover = false" width="60%" :close-on-click-modal="false"
            :append-to-body="true" top="60px">
            <el-table ref="multipleTable" :data="updPriceData" style="width: 100%"
                element-loading-text="拼命加载中" border 
                :header-cell-style="iscenter" stripe max-height="500px">

                <el-table-column prop="shopName" label="店铺" align="left"></el-table-column>
                <el-table-column prop="countryName" label="国家" width="80" align="left"></el-table-column>

                <el-table-column label="商品信息" align="left">
                    <template slot-scope="scope">
                        <div class="shop-info">
                            <div class="left">
                                <el-popover trigger="hover" placement="right">
                                    <img :src="scope.row.mainImage" class="prduct_img" alt />
                                    <div class="scope_img" slot="reference">
                                        <img :src="scope.row.mainImage" alt />
                                    </div>
                                </el-popover>
                            </div>
                            <div class="right">
                                <el-tooltip class="item" effect="light" :content="scope.row.sku" placement="top">
                                    <div class="title-cell">{{ scope.row.sku }}</div>
                                </el-tooltip>
                                <el-tooltip class="item" effect="light" :content="scope.row.asin" placement="top">
                                    <div class="title-cell">{{ scope.row.asin }}</div>
                                </el-tooltip>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="priceB2c" label="价格" align="left" width="150"></el-table-column>
                <el-table-column prop="priceAdjustment" label="价格调整" align="left" width="150">
                    <!-- 自定义表头 -->
                    <template #header>
                        <span>价格调整</span>
                        <el-popover
                            placement="top"
                            popper-class="table-popover"
                            width="260"
                            trigger="manual"
                            v-model="visibleForPricePopover">
                            <el-input clearable placeholder="请输入" class="change-num" v-model="changeNum" @input="changeNum = changeNum.trim()">
                                <el-select v-model="changeType" slot="prepend" style="width: 120px">
                                    <el-option label="指定值" value="指定值"></el-option>
                                    <el-option label="百分比增加" value="百分比增加"></el-option>
                                    <el-option label="百分比减少" value="百分比减少"></el-option>
                                    <el-option label="指定值增加" value="指定值增加"></el-option>
                                    <el-option label="指定值减少" value="指定值减少"></el-option>
                                </el-select>
                            </el-input>
                            
                            <div style="text-align: right; margin-top: 10px">
                                <el-button size="mini" type="text" @click="visibleForPricePopover = false">取消</el-button>
                                <el-button type="primary" size="mini" @click="confimUpdPrice">确定</el-button>
                            </div>
                            <el-button type="text" slot="reference" @click="visibleForPricePopover = !visibleForPricePopover">批量</el-button>
                        </el-popover>
                    </template>

                    <!-- 表格单元格内容（可选） -->
                    <template #default="{ row }">
                        <el-input v-model="row.priceAdjustment"></el-input>
                    </template>
                </el-table-column>
                
                <el-table-column label="操作"  width="100" align="left">
                    <template slot-scope="scope">
                        <el-button type="text" @click="removeItem(scope.row, scope.$index)">移除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="updPriceDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="onSumbit">发布</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../../api/api/api";
import ProductMatcher from './components/productMatcher.vue';
import { copyText, toFixedSafe } from '../../../utils/common';
export default {
    name: 'ProductList',
    components: {
        ProductMatcher
    },
    data() {
        return {
            // 计数
            total: 0,
            // 搜索条件
            startTime: '',
            // 店铺
            shopId: '',
            //店铺List
            dianpuList: [],
            endTime: '',
            searchStr: '',
            searchType: 'sku',
            // 表格数据
            summarylist: [],
            load_data: false,
            // 分页
            currentPage4: 1,
            size: 10,
            // 表格样式
            iscenter: {
                textAlign: "left",
                background: "#f8f8f8",
                color: "#232323",
            },
            // 用户信息
            UserInfo: null,
            // 选中数据
            batch_select: [],
            updPriceData: [],
            // 配对dialog
            pairDialogVisible: false,
            productData: {},
            status: '',
            pairStatus: '',
            priceMin: '',
            priceMax: '',
            currency: '',
            bizhongOptions: [],
            updPriceDialogVisible: false,
            visibleForPricePopover: false,
            changeType: '指定值',
            changeNum: '',
            dianPuMap: [],
        }
    },
    created() {
        this.UserInfo = JSON.parse(localStorage.getItem('role'))
        this.getDianPuList();
        this.getBizhong()
    },
    methods: {
        getBizhong(){
            const API = Baseurl + 'rateController/getAllRate'
			ajaxPost(API).then(res => {
				const { code, data } = res.data
				if (code === 200) {
					this.bizhongOptions = data
				} else {
					this.$message.error(data)
				}
			})
        },
        getRowStatus(status){
            let arr = [];
            try {
                arr = JSON.parse(status);
            } catch (error) {
                
            }
            if(arr.includes("BUYABLE")){
                return '在售';
            }
            return '停售';
        },
        // 加载表格数据
        async getDate(currentPage) {
            if (this.dianpuList.length > 0) {
                this.load_data = true;
                const arr = this.shopId.split('-');
                let params = {
                    page: currentPage,
                    size: this.size,
                    startTime: this.startTime,
                    endTime: this.endTime,
                    searchStr: this.searchStr,
                    searchType: this.searchType,
                    rid: this.UserInfo.rid,
                    sellerId: arr[1],
                    marketplaceId: arr[0]
                }
                if(this.status){
                    params.status = this.status
                }
                if(this.pairStatus !== "" && this.pairStatus !== undefined){
                    params.pairStatus = this.pairStatus
                }
                if(this.currency){
                    params.currencyCode = this.currency
                }
                if(this.priceMin){
                    params.minPrice = +this.priceMin
                }
                if(this.priceMax){
                    params.maxPrice = +this.priceMax
                }
                if(this.priceMax && this.priceMax){
                    if(+this.priceMax < +this.priceMin){
                        this.$message.error('最小值不能大于最大值')
                        return;
                    }
                }
                ajaxPost(Baseurl + "amazonProductOnline/selectListingsItems", params)
                    .then(res => {
                        if (res.data.code === 200) {
                            let list = res.data.data.list || [];
                            list = list.map(item => {   
                                item.status = this.getRowStatus(item.status);
                                return item;
                            });
                            this.summarylist = list
                            this.total = res.data.data.total
                            this.load_data = false
                        }
                    });
            } else {
                this.$message.error('当前角色暂未绑定店铺!')
            }
        },
        getDianPuList() {
            let params = {
                rid: this.UserInfo.rid,
                system: this.UserInfo.system,
                companyId: this.UserInfo.company_id,
                sellerType: 1,
            }
            ajaxPost(Baseurl + "roleController/selectNextAndSellerInfoByRid", params)
                .then(res => {
                    if (res.data.code === 200) {
                        const list = res.data.data.next;
                        const arr = [];
                        const dianPuMap = [];
                        for(let i = 0; i < list.length; i++){
                            const item = list[i];
                            for(let j = 0; j < item['countryMarks'].length; j++){
                                arr.push({
                                    label: item['countryMarks'][j]['shopName'],
                                    value: item['countryMarks'][j]['marketPlaceId'] + '-' + item['sellerId']
                                })
                                dianPuMap.push({
                                    ...item['countryMarks'][j],
                                    myValue: item['countryMarks'][j]['marketPlaceId'] + '-' + item['sellerId'],
                                    sellerId: item['sellerId'],
                                })
                            }
                        }
                        this.dianpuList = arr;
                        this.shopId = this.dianpuList[0].value;
                        this.dianPuMap = dianPuMap;
                        this.getDate(1)
                    }
                });
        },
        // 处理详情点击
        handleDetail(row) {
            console.log('查看详情:', row)
        },
        // 处理产品配对
        handleProductMatch(matchedProducts) {
            const params = {
                "listingIds": [this.productData.id],
                "id": matchedProducts.id,
                "platform": "amazon"
            }
            ajaxPost(Baseurl + "productController/pairListing", params).then(res => {
                if(res.data.code === 200){
                    this.$message.success('配对成功')
                    this.pairDialogVisible = false;
                    this.getDate(this.currentPage4)
                }
            })
        },
        // 选择站点后刷新页面
        shopChange(event) {
            this.getDate(1);
        },
        // 下拉菜单
        handleCommand(command, row) {
            switch (command) {
                case 'pair':
                    this.handlePair(row)
                    break
                case 'unpair':
                    this.handleUnpair(row)
                    break
            }
        },
        // 配对操作
        handlePair(row) {
            this.productData = row;
            this.pairDialogVisible = true;
        },
        // 取消配对
        handleUnpair(row){
            const params = {
                "productId": row.productLibraryList[0].id,
                "listingId": row.id
            }
            ajaxPost(Baseurl + "productListingPair/unpairProductListing", params).then(res => {
                if(res.data.code === 200){
                    this.$message.success('取消配对成功')
                    this.getDate(this.currentPage4)
                }
            })
        },
        // 搜索事件
        serach() {
            this.currentPage4 = 1
            this.getDate(1)
        },
        handleSizeChange(val) {
            this.size = val
            this.getDate(1)
        },
        handleCurrentChange(val) {
            this.currentPage4 = val
            this.getDate(val)
        },
        on_batch_select(val) {
            this.batch_select = val;
        },
        // 价格显示
        itemPrice(item) {
            return item.productPrice ? item.productPrice + (item.priceCurrency ? `(${item.priceCurrency})` : "") : ""
        },
        // 重置
        searchReset() {
            this.startTime = ""
            this.endTime = ""
            this.searchStr = ''
            this.searchType = 'sku';
            this.status = '';
            this.pairStatus = '';
            this.getDate(1);
        },
        // 更新数据操作
        del() {
            this.load_data = true;
            const arr = this.shopId.split('-');
            const sellerId = arr[1];
            ajaxPost(Baseurl + "amazonProductOnline/searchListingsItems", { sellerId: sellerId })
                .then(res => {
                    if (res.data.code === 200) {
                        this.$message({
                            type: "success",
                            message: "更新数据成功!",
                        });
                        this.getDate(1);
                        this.load_data = false
                    }
                });
        },
        copyText1(text){
            copyText(text).then(() => {
                this.$message.success('复制成功')
            }).catch(() => {
                this.$message.error('复制失败')
            })
        },
        updPrice(){
            if(this.batch_select.length === 0){
                this.$message.error('请选择产品')
                return;
            }
            this.updPriceData = JSON.parse(JSON.stringify(this.batch_select))
            this.updPriceDialogVisible = true;
        },
        //移除某一项
        removeItem(row, index){
            this.updPriceData.splice(index, 1);
            if(this.updPriceData.length === 0){
                this.updPriceDialogVisible = false;
            }
        },
        // 确定修改价格
        confimUpdPrice(){
            if(!this.changeNum){
                this.$message.error('请输入价格')
                return;
            }
            if(this.changeNum < 0){
                this.$message.error('价格不能小于0')
                return;
            }
            if(isNaN(this.changeNum)){
                this.$message.error('请输入数字')
                return;
            }
            switch(this.changeType){
                case '指定值':
                    this.updPriceData.forEach(item => {
                        this.$set(item, 'priceAdjustment', +this.changeNum)
                    })
                    break;
                case '指定值增加':
                    this.updPriceData.forEach(item => {
                        this.$set(item, 'priceAdjustment', toFixedSafe(+item.priceB2c + +this.changeNum, 2))
                    })
                    break;
                case '指定值减少':
                    this.updPriceData.forEach(item => {
                        this.$set(item, 'priceAdjustment', toFixedSafe(+item.priceB2c - +this.changeNum, 2))
                    })
                    break;
                case '百分比增加':
                    this.updPriceData.forEach(item => {
                        this.$set(item, 'priceAdjustment', toFixedSafe(+item.priceB2c * (1 + +this.changeNum / 100), 2))
                    })
                    break;
                case '百分比减少':
                    this.updPriceData.forEach(item => {
                        this.$set(item, 'priceAdjustment', toFixedSafe(+item.priceB2c * (1 - +this.changeNum / 100), 2))
                    })
                    break;
            }
            this.visibleForPricePopover = false;

        },
        onSumbit(){
            const rid = this.UserInfo.rid;
            const obj = this.dianPuMap.find(item => item.myValue == this.shopId);
            const params = {
                "sellerId": obj.sellerId,
                "locale": obj.region,
                "marketplaceId": obj.marketPlaceId,
                "rid": rid,
                "productOffers": this.updPriceData.map(item => {
                    return {
                        "sku": item.sku,
                        "purchasableOffer": {
                            "currency": item.currencyCode,
                            "our_price": [
                                {
                                    "schedule": [
                                        {
                                            "value_with_tax": item.priceAdjustment
                                        }
                                    ]
                                }
                            ],
                            // TGESA0000647-us-4 packs
                            "marketplace_id": item.marketplaceId
                        },
                        productType: item.productType
                    }
                })
            }
            ajaxPost(Baseurl + "amazonProductOnline/batchUpdatePrice", params).then(res => {
                if(res.data.code === 200){
                    this.$message.success('发布成功');
                    this.updPriceDialogVisible = false;
                    this.changeNum = '';
                    this.getDate(this.currentPage4)
                }
            })
        },
    }
}
</script>

<style lang="scss" scoped>
.summary {
    width: 100%;
    padding-bottom: 72px;

    .summary_bag {
        width: 100%;

        .summary_Date {
            width: 100%;
            // height: 50px;
            margin-top: 10px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            .block {
                // width: 20%;
                display: flex;
                align-items: center;
                margin-right: 30px;
                margin-bottom: 10px;
                &.search-bar{
                    flex: 1;
                    /deep/ .el-input__inner{
                        width: 200px;
                    }
                }
                &.price{
                    .text{
                        margin: 0 10px;
                    }
                }

                .el-input {
                    width: 180px;
                    margin: 0;
                }
                .el-select{
                    width: 180px;
                }

                .search {
                    border-radius: 4px;
                    background: #2c8dff;
                    color: #fff;
                    margin-left: 10px;
                    cursor: pointer;
                    width: 80px;
                    height: 30px;
                    line-height: 30px;
                    box-sizing: border-box;
                    text-align: center;
                }
            }
        }

        .summary_pagenum {
            width: 100%;
            margin: 10px 0;
            overflow: hidden;
            background: #f5f5f5;

            .summary_query {
                width: 20%;
                float: left;
                padding: 0 10px;
                box-sizing: border-box;
                line-height: 32px;
                letter-spacing: 1px;
                color: #585858;

                span {
                    color: #2c8dff;
                }
            }
        }

        .summary_content {
            width: 100%;
            border: 1px solid #eee;
            overflow: hidden;
            box-sizing: border-box;

            .summary_batch {
                width: 100%;
                overflow: hidden;
                border-bottom: 1px solid #eee;
                box-sizing: border-box;

                div {
                    float: left;

                    span {
                        display: block;
                        float: left;
                        line-height: 20px;
                        margin: 10px 0;
                        padding: 0 20px;
                        box-sizing: border-box;
                        color: #2c8dff;
                        border-left: 1px #2c8dff solid;
                        cursor: pointer;

                        &:first-child {
                            border-left: 0;
                        }
                    }
                }
            }

            .summary_list {
                .scope_img {
                    width: 55px;
                    height: 55px;
                    margin: 0 auto;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }
            }
        }

        .summary_pagenum_block {
            padding: 10px;
            box-sizing: border-box;
            background: #fff;
            position: fixed;
            bottom: 10px;
            left: 50%;
            transform: translateX(-50%);
            box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
            z-index: 10;
            border-radius: 10px;

            .el-pagination {
                display: flex;
                justify-content: center;
            }
        }
    }
}

.prduct_img {
    width: 500px;
    height: 500px;
}

.green-box {
    color: #67c23a;
    font-weight: bold;
}

.red-box {
    color: #f56c6c;
    font-weight: bold;
}

.title-cell {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 300px;
}

.el-dropdown {
    // margin-left: 10px;
    .el-button{
        padding: 0;
    }
}

.el-button [class*="el-icon-"]+span {
    margin-left: 5px;
}

.width67 {
    width: 67%;
}

.summary_top_shop {
    width: 100%;
    height: 40px;
    line-height: 40px;

    .role-Choice {
        width: 630px;
        float: left;

        span {
            line-height: 30px;
        }

        .el-select {
            width: 60%;
        }
    }
}
.sku-cell{
    width: 100%;
    display: flex;
    align-items: center;
    .text{
        flex: 1;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .el-button{
        margin-left: 5px;
        padding: 3px;
        box-sizing: border-box;
    }
}
.shop-info{
    display: flex;
    .scope_img{
        width: 100%;
        height: 100%;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .left{
        width: 50px;
        height: 50px;
        border: 1px solid #eee;
        box-sizing: border-box;
    }
    &>span{
        width: 100%;
        height: 100%;
    }
    .right{
        margin-left: 10px;
        text-align: left;
    }
}
.table-popover{
    z-index: 3000 !important;
    width: 250px !important;
}
</style>